import { render, staticRenderFns } from "./clueDetail.vue?vue&type=template&id=24c01381&scoped=true"
import script from "./clueDetail.vue?vue&type=script&lang=js"
export * from "./clueDetail.vue?vue&type=script&lang=js"
import style0 from "./clueDetail.vue?vue&type=style&index=0&id=24c01381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c01381",
  null
  
)

export default component.exports